import { useMutation, useQueryClient } from "@tanstack/react-query";

import {
  putPricesCategoriesPriceCategoryID,
  type SavePriceCategoryRequest,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { PRICE_CATEGORIES_QUERY_KEYS } from "PriceCategories/Api/Queries/queryKeys";

interface UpdatePriceCategoryParams {
  priceCategoryID: string;
  data: SavePriceCategoryRequest;
}

export function useUpdatePriceCategoryMutation() {
  const queryClient = useQueryClient();

  const mutationFn = processResponse(
    ({ priceCategoryID, data }: UpdatePriceCategoryParams) =>
      putPricesCategoriesPriceCategoryID(data, priceCategoryID),
  );

  return useMutation({
    mutationFn,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: PRICE_CATEGORIES_QUERY_KEYS.all,
      });
    },
  });
}
